module.exports = __webpack_public_path__ + "static/media/Panorama-Hills.5ea8b176.jpg";